export default __webpack_public_path__ + "static/media/OSMOS_CALCE-RIBBED_60X120_modulo_ribbed.900b7bd4.jpg";